<div class="stat-card" [ngClass]="hostClasses" [attr.aria-label]="ariaLabel || title" role="group">
    <div class="text">
        <div class="title" [innerHTML]="title.replace('\n','<br/>')"></div>
        <div class="value">{{ value }}</div>
    </div>

    <div class="badge" aria-hidden="true">
        <mat-icon>{{ icon }}</mat-icon>
    </div>
</div>
